import {
  ADD_LAB_PATHOLOGIST,
  ADD_LAB_PATHOLOGIST_SUCCESS,
  ADD_LAB_PATHOLOGIST_FAIL,
  GET_LAB_PATHOLOGISTS,
  GET_LAB_PATHOLOGISTS_SUCCESS,
  GET_LAB_PATHOLOGISTS_FAIL,
  DELETE_LAB_PATHOLOGIST,
  DELETE_LAB_PATHOLOGIST_SUCCESS,
  DELETE_LAB_PATHOLOGIST_FAIL,
} from "./actionTypes";

export const addLabPathologist = (labId, data) => ({
  type: ADD_LAB_PATHOLOGIST,
  payload: { labId, data },
});

export const addLabPathologistSuccess = data => ({
  type: ADD_LAB_PATHOLOGIST_SUCCESS,
  payload: data,
});

export const addLabPathologistFail = error => ({
  type: ADD_LAB_PATHOLOGIST_FAIL,
  payload: error,
});

export const getLabPathologists = () => ({
  type: GET_LAB_PATHOLOGISTS,
});

export const getLabPathologistsSuccess = data => ({
  type: GET_LAB_PATHOLOGISTS_SUCCESS,
  payload: data,
});

export const getLabPathologistsFail = error => ({
  type: GET_LAB_PATHOLOGISTS_FAIL,
  payload: error,
});

export const deleteLabPathologist = id => ({
  type: DELETE_LAB_PATHOLOGIST,
  payload: id,
});

export const deleteLabPathologistsSuccess = data => ({
  type: DELETE_LAB_PATHOLOGIST_SUCCESS,
  payload: data,
});

export const deleteLabPathologistsFail = error => ({
  type: DELETE_LAB_PATHOLOGIST_FAIL,
  payload: error,
});